'use client'

import type { PropsWithChildren } from 'react'
import { getChildTestIds } from '../../utils/testing.ts'
import { Text } from '../text/text.tsx'
import { useAlertContext } from './use-alert.ts'

export const AlertTitle = ({ children }: PropsWithChildren) => {
  const { dataTestId, dataTrackingId } = useAlertContext()
  return (
    <Text
      fontSize="lg"
      fontWeight="bold"
      {...getChildTestIds({ dataTestId, dataTrackingId }, 'title')}
    >
      {children}
    </Text>
  )
}
